<template>
  <div class="financial-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div v-if="terms == 1" class="financial-container">
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <!-- Header Section -->
        <div class="financial-header">
          <div class="header-content">
            <div class="title-section">
              <h1 class="page-title">
                <i class="fas fa-chart-line title-icon"></i>
                Sistema Financeiro
              </h1>
              <p class="page-subtitle">
                Gestão completa das finanças da instituição
              </p>
            </div>
          </div>
        </div>

        <!-- Navigation Tabs -->
        <div class="financial-navigation">
          <div class="nav-container">
            <div class="nav-tabs-modern" role="tablist">
              <!-- GERAL Tab -->
              <button
                v-if="permission('read', 'financial_general')"
                @click="handleStep('OVERVIEW')"
                :class="['nav-tab-modern', step == 'OVERVIEW' && 'active']"
                type="button"
                role="tab"
              >
                <i class="fas fa-chart-pie tab-icon"></i>
                <span class="tab-text">Geral</span>
              </button>

              <!-- LANÇAMENTOS Tab -->
              <button
                v-if="
                  permission('read', 'financial_credit') ||
                  permission('read', 'financial_debit') ||
                  permission('read', 'financial_transfer')
                "
                @click="handleStep('RELEASES')"
                :class="['nav-tab-modern', step == 'RELEASES' && 'active']"
                type="button"
                role="tab"
              >
                <i class="fas fa-plus-circle tab-icon"></i>
                <span class="tab-text">Lançamentos</span>
              </button>

              <!-- HISTÓRICO DE BOLETOS Tab -->
              <button
                v-if="permission('write', 'boleto')"
                @click="handleStep('BOLETO_HISTORY')"
                :class="[
                  'nav-tab-modern',
                  step == 'BOLETO_HISTORY' && 'active',
                ]"
                type="button"
                role="tab"
              >
                <i class="fas fa-file-invoice tab-icon"></i>
                <span class="tab-text">Boletos</span>
                <span class="tab-subtext">Histórico</span>
              </button>

              <!-- RELATÓRIOS Tab -->
              <button
                v-if="permission('read', 'financial_reports')"
                @click="handleStep('REPORTS')"
                :class="['nav-tab-modern', step == 'REPORTS' && 'active']"
                type="button"
                role="tab"
              >
                <i class="fas fa-chart-bar tab-icon"></i>
                <span class="tab-text">Relatórios</span>
              </button>

              <!-- CLIENTES Tab -->
              <button
                v-if="permission('read', 'financial_client')"
                @click="handleStep('CLIENT')"
                :class="['nav-tab-modern', step == 'CLIENT' && 'active']"
                type="button"
                role="tab"
              >
                <i class="fas fa-users tab-icon"></i>
                <span class="tab-text">Clientes</span>
              </button>

              <!-- FORNECEDORES Tab -->
              <button
                v-if="permission('read', 'financial_provider')"
                @click="handleStep('PROVIDER')"
                :class="['nav-tab-modern', step == 'PROVIDER' && 'active']"
                type="button"
                role="tab"
              >
                <i class="fas fa-truck tab-icon"></i>
                <span class="tab-text">Fornecedores</span>
              </button>

              <!-- CONFIGURAÇÃO Tab -->
              <button
                v-if="
                  permission('read', 'financial_account') ||
                  permission('read', 'financial_category') ||
                  permission('read', 'financial_profit_cost_center') ||
                  permission('read', 'financial_payment_methods') ||
                  permission('read', 'financial_tags') ||
                  permission('read', 'financial_document_types')
                "
                @click="handleStep('CONFIGURATION')"
                :class="['nav-tab-modern', step == 'CONFIGURATION' && 'active']"
                type="button"
                role="tab"
              >
                <i class="fas fa-cogs tab-icon"></i>
                <span class="tab-text">Configuração</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Content Area -->
        <div class="financial-content">
          <!-- OVERVIEW Content -->
          <div
            v-if="step == 'OVERVIEW'"
            :class="['content-panel', step == 'OVERVIEW' && 'active']"
          >
            <Overview
              @pay="handleToPay"
              @handle_to_releases="handleToReleases"
            />
          </div>

          <!-- RELEASES Content -->
          <div
            v-if="step == 'RELEASES'"
            :class="['content-panel', step == 'RELEASES' && 'active']"
          >
            <Releases />
          </div>

          <!-- BOLETO_HISTORY Content -->
          <div
            v-if="step == 'BOLETO_HISTORY'"
            :class="['content-panel', step == 'BOLETO_HISTORY' && 'active']"
          >
            <BoletoHistory />
          </div>

          <!-- REPORTS Content -->
          <div
            v-if="step == 'REPORTS'"
            :class="['content-panel', step == 'REPORTS' && 'active']"
          >
            <Reports />
          </div>

          <!-- PLANNING Content -->
          <div
            v-if="step == 'PLANNING'"
            :class="['content-panel', step == 'PLANNING' && 'active']"
          >
            <Planning />
          </div>

          <!-- CLIENT Content -->
          <div
            v-if="step == 'CLIENT'"
            :class="['content-panel', step == 'CLIENT' && 'active']"
          >
            <Client />
          </div>

          <!-- PROVIDER Content -->
          <div
            v-if="step == 'PROVIDER'"
            :class="['content-panel', step == 'PROVIDER' && 'active']"
          >
            <Provider />
          </div>

          <!-- CONFIGURATION Content -->
          <div
            v-if="step == 'CONFIGURATION'"
            :class="['content-panel', step == 'CONFIGURATION' && 'active']"
          >
            <Configuration />
          </div>
        </div>
      </b-overlay>
    </div>

    <Terms v-if="terms == 0" />
  </div>
</template>

<script>
import "../global/financial/styles.css";

import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import Terms from "../templates/User/terms";
import Overview from "../templates/Financial/Overview";
import Releases from "../templates/Financial/Releases";
import BoletoHistory from "../templates/Financial/BoletoHistory";
import Reports from "../templates/Financial/Reports";
import Planning from "../templates/Financial/Planning";
import Client from "../templates/Financial/Client";
import Provider from "../templates/Financial/Provider";
import Configuration from "../templates/Financial/Configuration";

import routes from "../routes";
import moment from "moment";
import permission from "../lib/permission";
import { userData } from "../lib/functions";

export default {
  name: "Financial",
  components: {
    NavBar,
    AuthBySessionExpired,
    Terms,
    Overview,
    Releases,
    BoletoHistory,
    Reports,
    Planning,
    Configuration,
    Client,
    Provider,
  },
  data() {
    return {
      mostrarBoleto: false,
      step: "",
      terms: 1,
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    handleToReleases(params) {
      let { nav } = routes.history.current.query;

      if (params) {
        let { launch } = params;
        if (nav != "releases") {
          routes.replace({ query: { nav: "releases", launch } });
        }
      } else {
        if (nav != "releases") {
          routes.replace({ query: { nav: "releases" } });
        }
      }

      this.step = "RELEASES";
    },
    handleStep(step) {
      let newNav = {
        OVERVIEW: "overview",
        RELEASES: "releases",
        REPORTS: "reports",
        CONFIGURATION: "configuration",
        PLANNING: "planning",
        CLIENT: "client",
        PROVIDER: "provider",
        BOLETO_HISTORY: "boleto_history",
      }[step];

      let { nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { nav: newNav } });
      }

      this.step = step;
    },
    handleToPay(item) {
      routes.replace({
        query: {
          nav: "releases",
          pay: item.id,
          date: moment(item.date).format("YYYY-MM-DD"),
        },
      });
      this.step = "RELEASES";
    },
    retrieve() {
      let { user } = userData();

      if (user) {
        if (user.rest_home_id == 1) {
          this.mostrarBoleto = true;
        }
      }

      const { nav } = routes.history.current.query;

      if (nav) {
        let step = {
          overview: "OVERVIEW",
          releases: "RELEASES",
          reports: "REPORTS",
          configuration: "CONFIGURATION",
          planning: "PLANNING",
          client: "CLIENT",
          provider: "PROVIDER",
          boleto_history: "BOLETO_HISTORY",
        }[nav];

        this.step = step;
      } else {
        this.step = "OVERVIEW";
      }
    },
  },
};
</script>

<style scoped>
.financial-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.financial-container {
  max-width: 100%;
  margin: 0 auto;
}

/* Header Section */
.financial-header {
  background: white;
  padding: 24px 0;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 8px 0 0 0;
  font-size: 16px;
}

/* Navigation Section */
.financial-navigation {
  margin-bottom: 10px;
  padding: 0 24px;
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
}

.nav-tabs-modern {
  display: flex;
  gap: 8px;
  background: white;
  padding: 8px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.nav-tabs-modern::-webkit-scrollbar {
  display: none;
}

.nav-tab-modern {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 8px 6px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #64748b;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  white-space: nowrap;
}

.nav-tab-modern:hover {
  background: rgba(15, 101, 176, 0.08);
  color: #0f65b0;
  transform: translateY(-2px);
}

.nav-tab-modern.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.tab-icon {
  font-size: 20px;
  margin-bottom: 2px;
  transition: all 0.3s ease;
}

.nav-tab-modern.active .tab-icon {
  color: white;
}

.tab-text {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.tab-subtext {
  font-size: 10px;
  font-weight: 400;
  opacity: 0.8;
  margin-top: 2px;
}

/* Content Area */
.financial-content {
  max-width: 1400px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.content-panel {
  padding: 10px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
  animation: fadeInUp 0.5s ease forwards;
  background-color: #fff;
}

.content-panel.active {
  opacity: 1;
  transform: translateY(0);
}

/* Loading Overlay */
.loading-overlay {
  border-radius: 16px;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .financial-header {
    padding: 20px 0;
  }

  .header-content {
    padding: 0 20px;
  }

  .financial-navigation {
    padding: 0 20px;
  }

  .financial-content {
    padding: 0 20px 32px;
  }

  .page-title {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .financial-header {
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
    text-align: center;
  }

  .financial-navigation {
    padding: 0 16px;
    margin-bottom: 24px;
  }

  .financial-content {
    padding: 0 16px 24px;
  }

  .page-title {
    font-size: 24px;
    justify-content: center;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .nav-tabs-modern {
    padding: 6px;
    gap: 4px;
  }

  .nav-tab-modern {
    min-width: 100px;
    padding: 12px 8px;
  }

  .tab-icon {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .tab-text {
    font-size: 11px;
  }

  .tab-subtext {
    font-size: 9px;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 0 12px;
  }

  .financial-navigation {
    padding: 0 12px;
  }

  .financial-content {
    padding: 0 12px 20px;
  }

  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  .nav-tab-modern {
    min-width: 80px;
    padding: 10px 6px;
  }

  .tab-icon {
    font-size: 16px;
  }

  .tab-text {
    font-size: 10px;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .nav-tab-modern {
    border: 2px solid transparent;
  }

  .nav-tab-modern:focus {
    border-color: #0f65b0;
    outline: none;
  }

  .nav-tab-modern.active {
    border-color: #0f65b0;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .nav-tab-modern,
  .content-panel {
    transition: none;
  }

  .content-panel {
    animation: none;
    opacity: 1;
    transform: none;
  }
}

/* Print styles */
@media print {
  .financial-header,
  .financial-navigation {
    display: none;
  }

  .financial-content {
    padding: 0;
    max-width: none;
  }
}
</style>